/**
 * Porta e TIENE lo scroll in cima per qualche frame.
 *
 * Un solo window.scrollTo(0, 0) non basta nelle WebView (iOS WKWebView e Despia su
 * Android): quando il documento si accorcia — al cambio pagina il contenuto vecchio
 * sparisce e resta un segnaposto alto quanto lo schermo — la WebView si ricorda
 * l'offset di prima e lo ri-applica appena il contenuto ricresce, cioè dopo la fetch.
 * Risultato: la pagina si apre inquadrando il fondo e poi scatta in cima.
 *
 * Ripetendo il reset a ogni frame per mezzo secondo il ripristino viene sovrascritto
 * prima del paint, quindi non si vede mai. Si ferma al primo gesto di scroll
 * dell'utente, così non gli blocchiamo mai la pagina sotto le dita.
 */
let annullaCorrente: (() => void) | null = null;

export function pinScrollTop(ms = 600): void {
  // Una sola sequenza attiva: la nuova pagina annulla quella della precedente.
  annullaCorrente?.();

  let attivo = true;
  const stop = () => {
    if (!attivo) return;
    attivo = false;
    window.removeEventListener("touchmove", stop);
    window.removeEventListener("wheel", stop);
    if (annullaCorrente === stop) annullaCorrente = null;
  };
  annullaCorrente = stop;

  // touchmove/wheel = l'utente sta scrollando davvero. Non usiamo touchstart: il tap
  // che ha aperto la pagina può ancora generarne uno.
  window.addEventListener("touchmove", stop, { passive: true });
  window.addEventListener("wheel", stop, { passive: true });

  const fine = performance.now() + ms;
  const frame = () => {
    if (!attivo) return;
    // Senza guardia su window.scrollY: in WKWebView lo scroll è gestito dal
    // compositore e il valore letto da JS può essere indietro di un frame.
    window.scrollTo(0, 0);
    if (performance.now() < fine) requestAnimationFrame(frame);
    else stop();
  };

  window.scrollTo(0, 0);
  requestAnimationFrame(frame);
}
